import { css } from "@emotion/react";
import styled from "@emotion/styled";
import * as React from "react";

import { Avatar, DesignToken } from "@livechat/design-system-react-components";

import Text from "components/layout/Text";

const Container = styled.div`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  align-items: center;
  white-space: nowrap;
  display: flex;
  line-height: 1.3;
  vertical-align: middle;
  gap: 6px;
`;

const Details = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: calc(100% - 30px);
  overflow: hidden;

  span {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const agentEmailCss = css`
  font-size: 13px;
  opacity: 0.5;
`;

interface IProps extends React.HTMLAttributes<HTMLElement> {
  agentId: string;
  avatarUrl: string;
  agentName: string;
  agentEmail: string;
  fontSize?: string;
  isLoggedInAgent?: boolean;
}

export const AgentDropdownItem: React.FC<IProps> = ({
  agentId,
  avatarUrl,
  fontSize = "15px",
  agentName,
  agentEmail,
  isLoggedInAgent,
  ...restProps
}) => (
  <Container {...restProps}>
    {agentId ? (
      <Avatar
        type={avatarUrl ? "image" : "text"}
        src={avatarUrl ? avatarUrl : undefined}
        text={agentName ?? agentEmail}
        size="xsmall"
      />
    ) : (
      <Avatar type="image" size="xsmall" />
    )}

    <Details>
      <Text inline fontSize={fontSize} className="fs-mask">
        {agentName}
        <Text inline fontSize={fontSize} color={`var(${DesignToken.ContentBasicDisabled})`} className="fs-mask">
          {isLoggedInAgent && " (You)"}
        </Text>
      </Text>
      <span css={agentEmailCss} className="fs-mask">
        {agentEmail}
      </span>
    </Details>
  </Container>
);
